import React from 'react';

import IFormFieldProps from 'pods/forms/components/formFieldProps.d';
import Card from 'core/components/Card';

interface IProps extends IFormFieldProps {
	children: any;
}

/**
 * Card container inside forms
 * @param isShown - This is created to cater for custom hiding without using form rules.
 * @returns
 */
const CardContainer = ({ config, children }: IProps) => {
	const { isShown, topChildren, bottomChildren, ...cardProps } =
		config?.data ?? {};

	return (
		<>
			{isShown ? (
				<Card {...cardProps}>
					{topChildren ?? null}
					{children}
					{bottomChildren ?? null}
				</Card>
			) : null}
		</>
	);
};

export default CardContainer;
